module.exports = __webpack_public_path__ + "static/media/NewLastRole.2c55c48c.svg";